import { useLocalSearchParams } from 'expo-router';

import { ThreadDetail } from '@/screens/thread-detail';

export default function ThreadDetailScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  return <ThreadDetail threadId={id} />;
}
